<style lang="scss">
  @import '../../../sass/variables';

  .automation-builder-modal {
    top: 0;
    right: 0;
    z-index: 10;
    width: 380px;
    height: 100%;
    display: flex;
    cursor: initial;
    position: absolute;
    flex-direction: column;

    &__header {
      width: 100%;
      height: 50px;
      display: flex;
      padding: 0 28px;
      font-weight: 500;
      color: $white-gray;
      align-items: center;
      letter-spacing: -.17px;
      border-radius: 16px 0 0;
      justify-items: flex-start;
      text-transform: uppercase;
      background-color: $gray-dark;
    }

    &__row {
      padding: 16px 28px;
    }

    &__action {
      margin: 0 auto;
      display: block;
    }

    &__help {
      font-size: 11px;
      margin-top: 8px;
      font-weight: 400;
      line-height: 16px;
      color: $gray-light;
    }

    &__title {
      margin: 0;
      font-size: 11px;
    }

    &__button {
      padding: 0;
      border: none;
      background: none;
      margin-right: 16px;

      &-icon {
        color: $white-gray;
      }

      &--right {
        margin-right: 0;
        margin-left: auto;
      }
    }

    &__search {
      width: 100%;
      padding: 16px 28px;
      position: relative;
      background-color: $white;

      &-input {
        border: 0;
        width: 100%;
        font-size: 11px;
        font-weight: 400;
        color: $gray-light;
        border-radius: 6px;
        letter-spacing: -.17px;
        padding: 14px 56px 14px 20px;
        background-color: $white-gray;
      }

      i {
        top: 28px;
        right: 48px;
        font-size: 16px;
        color: $gray-light;
        position: absolute;
      }
    }

    &__body {
      flex: 1;
      overflow-y: auto;
      overflow-x: hidden;
      background-color: $white;
    }

    &__item {
      display: flex;
      padding: 16px 28px;
      align-items: flex-start;
      border-bottom: 1px solid $white-gray;

      &-icon {
        width: 40px;
        height: 40px;
        display: flex;
        color: $white;
        font-size: 19px;
        border-radius: 50%;
        align-items: center;
        justify-content: center;
        background-color: $purple;

        i {
          color: $white;
          font-size: 19px;
          margin-right: 0px;
          align-items: center;
          justify-content: center;
        }
      }

      &-body {
        flex: 1;
        margin-left: 12px;
      }

      &-title {
        margin: 0;
        font-size: 13px;
        font-weight: 500;
        color: $gray-dark;
        line-height: 18px;
        padding-bottom: 6px;
        letter-spacing: -.2px;
      }

      &-description {
        margin: 0;
        font-size: 11px;
        font-weight: 500;
        line-height: 18px;
        color: $gray-light;
        padding-bottom: 4px;
        letter-spacing: -.17px;
      }

      &-warning {
        font-size: 10px;
        font-weight: 500;
        line-height: 18px;
        color: $gray-light-2;
        padding-bottom: 4px;
        letter-spacing: -.17px;
        margin: 3px 0px 0px 0px;
      }

      &-button {
        opacity: 0;
        font-size: 11px;
        font-weight: 500;
        padding: 2px 4px;
        line-height: 18px;
        border-radius: 3px;
        color: $gray-light;
        letter-spacing: -.17px;
        border: 1px solid $gray;
        background-color: $white-gray;
      }

      &:not(&--active):hover {
        border-color: $green;
      }

      &:hover &-badge,
      &:hover &-button {
        opacity: 1;
      }

      &-badge {
        opacity: 0;
      }

      &:nth-child(even) {
        background-color: $white-gray;
      }
    }

    .multiselect--above .multiselect__content-wrapper {
      position: inherit;
    }
  }
</style>

<template>
  <div
    @mousedown.stop
    @mousewheel.stop
    class="automation-builder-modal"
    id="automation-builder-modal"
  >
    <div class="automation-builder-modal__header">
      <button
        v-if="value && ! selected"
        @click.prevent="$emit('input', null)"
        class="automation-builder-modal__button"
      >
        <i class="automation-builder-modal__button-icon fa fa-chevron-left" />
      </button>

      <h5
        v-text="_title"
        class="automation-builder-modal__title"
      />

      <button
        @click.prevent="$emit('close')"
        class="automation-builder-modal__button automation-builder-modal__button--right"
      >
        <img
          src="/build/icons/close@white.svg"
          alt="Fechar"
          width="14"
          height="13"
        >
      </button>
    </div>

    <div
      v-if="placeholder && ! selected"
      class="automation-builder-modal__search"
    >
      <input
        type="text"
        name="search"
        v-model="search"
        :placeholder="placeholder"
        class="automation-builder-modal__search-input"
      >

      <i class="fa fa-search" />
    </div>

    <div
      v-if="isArray && selected"
      class="automation-builder-modal__body"
    >
      <div
        class="automation-builder-modal__item automation-builder-modal__item--active"
      >
        <span class="automation-builder-modal__item-icon">
          <i :class="selected.icon" />
        </span>

        <div class="automation-builder-modal__item-body">
          <h4
            v-html="__(selected.name)"
            class="automation-builder-modal__item-title"
          />

          <p
            v-if="selected.description"
            v-html="__(selected.description)"
            class="automation-builder-modal__item-description"
          />

          <p
            v-if="selected.warning"
            v-html="__(selected.warning)"
            class="automation-builder-modal__item-warning"
          />
        </div>
      </div>

      <slot />

      <button
        :disabled="disabled"
        @click.prevent="$emit('save')"
        class="automation-builder-modal__action btn btn-primary"
      >
        {{ selected ? __('Salvar') : __('Adicionar') }}
      </button>
    </div>

    <div
      v-else-if="isArray"
      class="automation-builder-modal__body"
    >
      <div
        :key="key"
        v-for="({ key, icon, name, description, locked }) in filtered"
        class="automation-builder-modal__item"
      >
        <span class="automation-builder-modal__item-icon">
          <i :class="icon" />
        </span>

        <div class="automation-builder-modal__item-body">
          <h4
            v-html="__(name)"
            class="automation-builder-modal__item-title"
          />

          <p
            v-if="description"
            v-html="__(description)"
            class="automation-builder-modal__item-description"
          />

          <button
            v-if="button && ! locked"
            v-text="button"
            @click.prevent="$emit('input', key)"
            class="automation-builder-modal__item-button"
          />

          <span
            v-if="locked"
            class="automation-builder-modal__item-badge badge badge-box badge-upgrade"
          >{{ __('Update da conta') }}</span>
        </div>
      </div>
    </div>

    <slot v-else />
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },

    value: {
      //
    },

    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },

    placeholder: {
      type: String,
      required: false,
    },

    items: {
      //
    },

    button: {
      type: String,
      required: false,
    },
  },

  data: () => ({
    search: '',
  }),

  computed: {
    selected () {
      return this.items.find(({ key }) => this.value == key);
    },

    filtered () {
      return this.items.filter(({ name }) => name.toLowerCase().indexOf(this.search.toLowerCase()) !== -1);
    },

    _title () {
      if (this.selected) {
        return this.__(this.selected.name);
      }

      return this.__(this.title);
    },

    isArray () {
      return Array.isArray(this.items);
    },
  },
};
</script>
